import React from 'react';
import { Box, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material';
import { SUBSCRIPTION_STATUS_OPTIONS } from '../../../constants/subscriptionStatusOptions';
import type { SubscriptionStatus } from '../../../types/features/storeSummaryListing';

interface StoreSummaryFiltersBarProps {
  statusFilter: SubscriptionStatus;
  onStatusChange: (value: SubscriptionStatus) => void;
  search: string;
  onSearchChange: (value: string) => void;
}

const StoreSummaryFiltersBar: React.FC<StoreSummaryFiltersBarProps> = ({
  statusFilter,
  onStatusChange,
  search,
  onSearchChange,
}) => (
  <Grid container spacing={2} alignItems="center" justifyContent="flex-end">
    <Grid size={{ xs: 12, md: 4 }}>
      <FormControl
        fullWidth
        size="small"
        sx={{
          '& .MuiInputLabel-root, & .MuiSelect-select': {
            fontSize: '15px',
          },
        }}
      >
        <InputLabel id="subscription-status-label">Subscription Status</InputLabel>
        <Select
          labelId="subscription-status-label"
          label="Subscription Status"
          value={statusFilter}
          sx={{ '& .MuiSelect-select': { padding: '10px 12px !important' } }}
          onChange={(event: SelectChangeEvent<SubscriptionStatus>) =>
            onStatusChange(event.target.value as SubscriptionStatus)
          }
        >
          {SUBSCRIPTION_STATUS_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    <Grid size={{ xs: 12, md: 5 }}>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-start' }}>
        <TextField
          fullWidth
          label="Search Stores"
          size="small"
          value={search}
          onChange={(event) => onSearchChange((event.target.value || '').toString())}
          placeholder="Search by store name..."
          sx={{
            '& .MuiInputBase-input, & .MuiInputLabel-root': {
              fontSize: '15px',
            },
          }}
        />
      </Box>
    </Grid>
  </Grid>
);

export default React.memo(StoreSummaryFiltersBar);
